import React from "react";
import "./BatteryCellVoltage.css";

const BatteryCellVoltage = ({ cellVoltages }) => {
  return (
    <div className="battery-grid">
      {cellVoltages.map((voltage, index) => (
        <div key={index} className="battery-cell">
          <div className="cell-title">Cell {index + 1}</div>
          <div className="voltage-value">{voltage} V</div>
        </div>
      ))}
    </div>
  );
};

export default BatteryCellVoltage;
